









































































































































































































import { Component, Mixins } from "vue-property-decorator";
import Search from "@/components/elements/utility/Search.vue";
import DataTable from "@/components/elements/utility/Table.vue";
import UserService from "@/services/user_service";
import OrderService from "@/services/order_service";
import { LineItem, Order } from "@/models/order/order";
import { makeTitleCase } from "@/utility/helpers";
import { OrderStatus } from "@/models/order/helpers";
import { Mobile } from "@/mixins/mobile";
import ConfirmClearAll from "@/components/elements/modal/ConfirmClearAll.vue";
import { OrderMixin } from "@/mixins/orders/mixin";
import { namespace } from "vuex-class";
import { StoreModule } from "@/store/types";
import { GlobalGetters } from "@/store/modules/global/types";

@Component({
  components: {
    Search,
    DataTable,
    ConfirmClearAll,
  },
})
export default class OrderList extends Mixins(Mobile, OrderMixin) {
  @(namespace(StoreModule.Global).Getter(GlobalGetters.GetRole))
  userRole!: string;

  private search = "";
  protected makeTitleCase = makeTitleCase;
  protected orderStatus = OrderStatus;
  protected userService = new UserService();
  protected orderService = new OrderService();
  protected orders: Order[] = [];

  async created() {
    this.orders = await this.userService.getUsersOrders(this.userRole);
  }

  // Triggered from child component, <Search />
  protected submitSearch(searchTerm: string): void {
    this.search = searchTerm;
  }

  protected getMultiplier(items: LineItem[]): number {
    // 11/3/2023_FUPOF-137: Quotes are to have the same multiplier for all items.
    let multiplier = 1;
    if (items.length > 0 && items[0].multiplier) {
      multiplier = items[0].multiplier;
    }
    return multiplier;
  }

  protected getItems(items: LineItem[]): number {
    let num = 0;
    for (const item of items) {
      num = num + item.qty;
    }
    return num;
  }

  protected getTotal(items: LineItem[], costDetails: any): number {
    let num = 0;
    for (const item of items) {
      num = num + item.qty * item.unit_price * item.multiplier;
    }
    if (costDetails) {
      if (costDetails.shipping) {
        num += costDetails.shipping;
      }
      if (costDetails.tax) {
        num += costDetails.tax;
      }
    }
    return num;
  }

  get filteredOrders() {
    let orders = this.orders.sort(function(a, b) {
      //@ts-ignore
      return (new Date(b.created_at) as any) - (new Date(a.created_at) as any);
    });
    orders = orders.filter((o) => o.status !== OrderStatus.Converted);
    const filter = (orders as any[]).filter(
      (o) => o.status === OrderStatus.Open
    );
    const filter2 = (orders as any[]).filter(
      (o) => o.status === OrderStatus.Submitted
    );
    orders = filter.concat(filter2);
    if (this.search !== "") {
      const filter = (orders as any[]).filter((item) => {
        if (item.customer_id) {
          return (
            item.customer_id.customer_name
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) !== -1
          );
        }
      });
      const filter2 = (orders as any[]).filter((item) => {
        return (
          item.contact_details.quote_name
            .toLowerCase()
            .indexOf(this.search.toLowerCase()) !== -1
        );
      });
      return filter.concat(filter2);
    } else {
      return orders;
    }
  }
}
